import { useMemo } from 'react'
export default function BackgroundFX({ count = 18 }) {
  const particles = useMemo(
    () =>
      Array.from({ length: count }).map((_, i) => {
        const size = 3 + Math.random() * 7
        return {
          id: i,
          size,
          left: Math.random() * 100,
          duration: 10 + Math.random() * 14,
          delay: Math.random() * 12,
          drift: `${Math.random() * 120 - 60}px`,
        }
      }),
    [count]
  )

  return (
    <div className="ambient-particles" aria-hidden="true">
      {particles.map((p) => (
        <span
          key={p.id}
          style={{
            width: p.size,
            height: p.size,
            left: `${p.left}%`,
            animationDuration: `${p.duration}s`,
            animationDelay: `${p.delay}s`,
            '--drift': p.drift,
          }}
        />
      ))}
    </div>
  )
}
